import * as React from 'react'
import { Link} from 'react-router-dom'
import { Grid, Typography, Box, Button} from '@mui/material'
import { ErrorAlert } from '../../alerts/ErrorAlert'
import { axiosErrorHandling } from '../../misc/other'
import axios from 'axios'
import HomeIcon from '@mui/icons-material/Home'



export const Completed = ()=>{


const context = JSON.parse(window.localStorage.getItem('context'))

const path =  '../accounts/' + context.email   
const [errorMessage, setErrorMessage] = React.useState('')
const [error, setError] = React.useState(false)

const closeError = () =>{
    setError(false)
}

React.useEffect(()=>{
    
    
    const activeAccounts = context.active_accounts - context.accounts_settled
    axios({method: 'POST',
           url: 'api/oracle3/activeaccounts',
           data: {customer_number: context.customer_number, active_accounts:activeAccounts}     
    }).catch(err=>{
        let errMessage = axiosErrorHandling(err)
        setErrorMessage(errMessage)
        setError(true)
        
    })

},[])









    return(
       
        <Box sx={{minHeight:'80vh', mt: 15, mb: 2}}>
         <ErrorAlert open={error} error={errorMessage} handleClose={closeError}/>  
        <Grid container direction='row' sx={{justifyContent:'center', alignItems:'center'}}>
        <Grid size={{xs: 7, sm: 6, lg: 4 }}>
        <Typography variant='h6'gutterBottom={true}>Payment Processed...Check your download folder for the settlement letter.  Keep the letter on file for future reference. If any other entity requests to settle the debt please show them this letter. Also NameMySettlement.com will be sending you a receipt by the end of the next business day </Typography>
        </Grid>
        </Grid>
        <Grid container direction='row' sx={{justifyContent:'center', alignItems:'center'}}>
        <Grid>
        <Button endIcon={<HomeIcon />} component={Link} to={path}  variant='contained' color='primary'> Go Back To Account Home </Button>
        
        </Grid>
        </Grid>
        
        </Box>
        
        
    )

}